<template>
  <a
    v-if="link"
    :target="link.target"
    :href="link.url"
    :data-qa="qaHook"
    class="js-track-click"
    @click="$emit('click', $event)"
  >
    {{ link.text }} <icon icon="chevron-right-oval" />
  </a>
</template>

<script>
import Icon from '@/components/generic/presentational/atoms/icon/Icon.vue'

export default {
  components: {
    Icon,
  },
  props: {
    link: {
      type: Object,
      default: null,
    },
    qaHook: {
      type: String,
      default: '',
    },
  },
  emits: ['click'],
}
</script>

<style lang="scss" scoped>
svg {
  @include icon;

  top: -0.1em;
  transition: transform 0.2s ease-out;
  vertical-align: middle;
}

a {
  display: inline-block;
  font-weight: $font-weight-bold;

  &:hover {
    text-decoration: none;

    svg {
      transform: translateX(0.25em);
    }
  }
}
</style>
